import { render, staticRenderFns } from "./LegalEntity.vue?vue&type=template&id=d7e08070&"
import script from "./LegalEntity.vue?vue&type=script&lang=js&"
export * from "./LegalEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7e08070')) {
      api.createRecord('d7e08070', component.options)
    } else {
      api.reload('d7e08070', component.options)
    }
    module.hot.accept("./LegalEntity.vue?vue&type=template&id=d7e08070&", function () {
      api.rerender('d7e08070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/LegalEntity.vue"
export default component.exports